<template>

  <div wrapper>

    <!--
    CRUCIAL WE GO FROM FINALS TO QUARTERFINAL.
    DISPLAYED VIA FLEX-REVERSE SO THAT IS CAN GO FINALS DOWN IN DISPLAY: BLOCK ON MOBILE.
    -->
    <div class="round" round="finals">

      <h4 class="round-title">
        Finals
      </h4>

      <div class="matches">
        <match-card class="match"/>
      </div>

    </div>

    <div class="round" round="semifinals">

      <h4 class="round-title">
        Semifinals
      </h4>

      <div class="matches">
        <match-card class="match"/>
        <match-card class="match"/>
      </div>

    </div>

    <div class="round" round="quarterfinals">

      <h4 class="round-title">
        Quarterfinals
      </h4>
      <div class="matches">
        <match-card class="match"/>
        <match-card class="match"/>
        <match-card class="match"/>
        <match-card class="match"/>
      </div>

    </div>

    <div class="round" round="octofinals">

      <h4 class="round-title">
        Sweet 16
      </h4>

      <div class="matches">
        <match-card class="match"/>
        <match-card class="match"/>
        <match-card class="match"/>
        <match-card class="match"/>
        <match-card class="match"/>
        <match-card class="match"/>
        <match-card class="match"/>
        <match-card class="match"/>
      </div>

    </div>






  </div>

</template>

<script>

	import MatchCard from "./MatchCard"

	export default {
		name: "Bracket",
		components: {
			MatchCard,
		}
	}
</script>

<style lang="less" scoped>

  @import "../../../assets/less/palette.less";
  @import "../../../assets/less/theme.less";

  //this needs to match the settings in MatchCard.vue!
  @match-card-width: 240px;
  @match-card-height: 80px;
  @match-min-vertical-margin: 4px;
  @linecolor: @dark-bg;
  @round-hor-margin: @match-card-width * .08;

  [wrapper] {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    flex: 0;
    margin: 4px auto;
  }

  .round {

    .matches {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      padding: 0 @round-hor-margin;
      flex: 0;
    }

    .round-title {
      display: none;
    }

    .matches > * {
      position: relative;
      z-index: 3;
    }

    //here we fix margins so that we can guarantee that bracket lines will line up and we know the card in the next
    //row will always be in the center.

    .right-side-connectors {
      content: " ";
      width: @round-hor-margin;
      border: 1px solid @linecolor;
      border-left: none;

      position: absolute;
      z-index: 1;
      right: -@round-hor-margin;
      bottom: @match-card-height/2;
    }

    .left-side-connectors {
      content: " ";
      width: @round-hor-margin;
      border-bottom: 1px solid @linecolor;
      height: 1px;

      position: absolute;
      z-index: 1;
      left: -@round-hor-margin;
      bottom: @match-card-height/2;
    }

    &[round="octofinals"] {

      .matches > * {
        margin: @match-min-vertical-margin 0;

        &:nth-child(even)::after {
          height: @match-card-height + @match-min-vertical-margin * 2;
          .right-side-connectors();
        }
      }
    }

    &[round="quarterfinals"] {
      @quartermargin: (@match-min-vertical-margin + @match-card-height/2);

      .matches > * {
        margin: @quartermargin 0;

        &:nth-child(even)::after {
          height: @match-card-height + @quartermargin * 2;
          .right-side-connectors();
        }

        &::before {
          .left-side-connectors();
        }

      }
    }

    &[round="semifinals"] {
      @semimargin: (@match-min-vertical-margin * 2 + @match-card-height * 1.5);
      .matches > * {
        margin: @semimargin 0;

        &:nth-child(even)::after {
          height: @match-card-height + @semimargin * 2;
          .right-side-connectors();
        }

        &::before {
          .left-side-connectors();
        }
      }
    }

    &[round="finals"] {

      .matches > * {

        margin: @match-min-vertical-margin 0;

        &::before {
          .left-side-connectors();
        }
      }
    }

  }

  @media (max-width: @breakpoint-medium) {

    [wrapper] {
      display: block;
      margin: 0 auto;
    }

    .round {

      .matches {
        margin: 3em auto;
        padding: 0;
        display: block;

      }

      .round-title {
        display: block;
      }

      .matches > * {
        margin: @match-min-vertical-margin 0 !important;

        &::after, &::before {
          display: none !important;
        }
      }
    }

  }


</style>
